import { destroy, downloadFile, post, put } from 'app/shared/utils/fetchr';

// Utils
import routes from 'app/shared/utils/routes';

// Models
import {
  BulkDeactivatePayload,
  EditRulePayload,
  RuleEntitiesWhitelistPayload,
} from 'app/modules/rules/models';

// Actions
import {
  deployShadowRule as deployShadowRuleAction,
  retrieveRules as retrieveRulesAction,
  retrieveRuleValidationAlertEntities as retrieveRuleValidationAlertEntitiesAction,
} from 'app/modules/rules/actions';
import { DetectionModel } from 'app/modules/detectionModels/models';
import {
  BulkDeactivateRulesResponse,
  RuleImportResponse,
  SingleRuleImportResult,
} from 'app/modules/detectionModels/types/responses';

export const deleteValidationRule = (id: number) => {
  const path = routes.patronus.validationRulesIdDelete.replace(
    ':id',
    String(id),
  );
  return destroy(path);
};

export const retrieveRuleValidationAlertEntities = (
  payload: ReturnType<
    typeof retrieveRuleValidationAlertEntitiesAction
  >['payload'],
) => {
  const { id, ...data } = payload;
  const path = routes.patronus.ruleValidationAlertsIdEntities.replace(
    ':id',
    String(id),
  );
  return post(path, data);
};

export const deployShadowRule = (
  payload: ReturnType<typeof deployShadowRuleAction>['payload'],
) => {
  const { id, ...details } = payload;
  const path = routes.patronus.shadowRulesIdDeploy.replace(':id', String(id));
  return post(path, details);
};

export const retrieveRules = (
  payload: ReturnType<typeof retrieveRulesAction>['payload'],
) => {
  return post(routes.patronus.rulesList, payload);
};

export const bulkDeactivate = (payload: BulkDeactivatePayload) =>
  post<BulkDeactivateRulesResponse>(
    routes.patronus.rulesBulkDeactivate,
    payload,
  );

export const exportRules = (
  payload: number[],
  fileName: string,
): Promise<Record<string, never>> =>
  downloadFile('/v1/rules/export-rules', fileName, 'POST', payload);

export const importRules = (payload: string): Promise<RuleImportResponse> =>
  post('/v1/rules/import-rules', payload);

export const downloadFileImportErrorFile = (
  payload: SingleRuleImportResult[],
  fileName: string,
) => {
  downloadFile(
    '/v1/file-exports/download/rule-import-errors',
    fileName,
    'POST',
    payload,
  );
};

export const addWhitelistedEntitiesForRule = (
  payload: RuleEntitiesWhitelistPayload,
) => {
  return post(routes.patronus.rulesWhitelistEntities, payload);
};

export const editRule = (payload: EditRulePayload) => {
  const { id, ...data } = payload;
  return put<DetectionModel>(
    routes.patronus.rulesEditId.replace(':id', `${id}`),
    data,
  );
};
